import { rm, combineReducers } from 'utils';
import {
  BaseAction,
  BaseInitialState,
  BaseState,
  baseFormReducer,
  baseReducer
} from 'components/CustomerSupportForms/Utils';
import { isCustomerContactValid } from '../Components/CustomerContact/utils';

type InternalState = BaseState & {
  question: string;
  questionError?: string;
};

export const otherQuestionsInitialState: InternalState = {
  ...BaseInitialState,
  question: '',
  questionError: ''
};

type Action =
  | { type: 'question'; value: string }
  | { type: 'questionError'; value: string }
  | BaseAction;

export const otherQuestionsReducer = (state: InternalState, action: Action): InternalState => {
  switch (action.type) {
    case 'question':
      return { ...state, question: action.value };
    case 'questionError':
      return { ...state, questionError: action.value };
    default:
      return state;
  }
};

export const reducer = combineReducers<InternalState, Action>(
  baseFormReducer,
  baseReducer,
  otherQuestionsReducer
);

export const isValid = (state: InternalState, dispatch: (action: Action) => void) => {
  let isValid = true;

  if (state.question === '') {
    dispatch({
      type: 'questionError',
      value: rm('Customerpage_OtherQuestion_Validation_Error')
    });
    isValid = false;
  }

  isValid = isCustomerContactValid({ state, valid: isValid, dispatch });

  return isValid;
};
